import StreamingPlatform from './StreamingPlatform';

export default StreamingPlatform;
